<template>
  <div class="popover-wrapper d-flex flex-column justify-end">
    <ScrollTop v-once href="#content" />
    <TheNps v-if="canShowNps" @close="closeNps" />
    <MessageWrapper />
    <slot />
  </div>
</template>

<script>
import ScrollTop from '@/components/basic/atoms/TheScrollTop.vue'
import { defineAsyncComponent } from 'vue'

const MessageWrapper = defineAsyncComponent(
  () => import('@/components/basic/molecules/MessageWrapper.vue')
)
const TheNps = defineAsyncComponent(
  () => import('@/components/basic/organisms/TheNps.vue')
)

const SHOW_SURVEY_TIME = 60000
const NPS_COOKIE = 'vic_nps_disabled'

export default {
  components: { TheNps, ScrollTop, MessageWrapper },
  props: {
    showNps: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      canShowNps: false
    }
  },
  methods: {
    async checkNps() {
      if (!this.showNps || this.$vuetify.display.smAndDown) return
      const { default: CookieHelper } = await import(
        '@/services/helpers/CookieHelper'
      )
      this.canShowNps = !CookieHelper.getCookie(NPS_COOKIE)
    },
    async closeNps() {
      const { default: CookieHelper } = await import(
        '@/services/helpers/CookieHelper'
      )
      CookieHelper.setCookie(NPS_COOKIE, '1', 60)
      this.canShowNps = false
    }
  },
  mounted() {
    setTimeout(this.checkNps, SHOW_SURVEY_TIME)
  }
}
</script>

<style scoped>
.popover-wrapper {
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  top: 0;
  z-index: 999;
  pointer-events: none;

  > * {
    pointer-events: all;
  }
}
.display-lg-and-up .popover-wrapper {
  right: auto;
  left: auto;
}
</style>
